import { useState, useCallback, useMemo } from 'react';
import type { CreditBalance, CreditTransaction, CreditPackage } from '@/types/api.types';

const mockBalance: CreditBalance = {
  available: 2847,
  reserved: 153,
  expires: 'January 15, 2027',
  processingRate: '1 credit = 1 client record',
  averageUsage: 150,
  estimatedWeeksRemaining: 19,
};

const mockTransactions: CreditTransaction[] = [
  { id: 't1', date: '2025-01-20', description: 'RealPage Processing', type: 'usage', amount: -247, balance: 2847 },
  { id: 't2', date: '2025-01-15', description: 'Credit Purchase - Professional', type: 'purchase', amount: 5000, balance: 3094 },
  { id: 't3', date: '2025-01-12', description: 'Mass Tort Processing', type: 'usage', amount: -156, balance: -94 },
  { id: 't4', date: '2025-01-08', description: 'Accuracy Refund', type: 'refund', amount: 12, balance: 3406 },
  { id: 't5', date: '2024-12-28', description: 'RealPage Processing', type: 'usage', amount: -312, balance: 3394 },
  { id: 't6', date: '2024-12-20', description: 'Credit Purchase - Starter', type: 'purchase', amount: 1000, balance: 3706 },
];

const mockPackages: CreditPackage[] = [
  { id: 'starter', name: 'Starter Pack', credits: 1000, price: 99, pricePerCredit: 0.099, validity: '24 months' },
  { id: 'professional', name: 'Professional', credits: 5000, price: 449, pricePerCredit: 0.09, validity: '24 months', popular: true, savings: '10%' },
  { id: 'enterprise', name: 'Enterprise', credits: 25000, price: 1999, pricePerCredit: 0.08, validity: '24 months', savings: '20%' },
];

export function useCreditBalance() {
  const [balance] = useState<CreditBalance>(mockBalance);
  const [transactions] = useState<CreditTransaction[]>(mockTransactions);
  const [packages] = useState<CreditPackage[]>(mockPackages);
  const [isLoading, setIsLoading] = useState(false);

  const isLowBalance = useMemo(() => balance.available < 500, [balance.available]);

  const purchaseCredits = useCallback(async (packageId: string) => {
    setIsLoading(true);
    // Placeholder for Stripe integration
    await new Promise((r) => setTimeout(r, 1500));
    setIsLoading(false);
  }, []);

  return {
    balance,
    transactions,
    packages,
    isLowBalance,
    isLoading,
    purchaseCredits,
  };
}